import { render } from "./UnassignedDevicesSection.vue?vue&type=template&id=66f120a1"
import script from "./UnassignedDevicesSection.vue?vue&type=script&lang=js"
export * from "./UnassignedDevicesSection.vue?vue&type=script&lang=js"
script.render = render

export default script